import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import Body from '../Blocks/Decoration/Body';

import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import LogoHeaderDesktop from '../Logo/LogoHeaderDesktop';
import LogoHeaderMobile from '../Logo/LogoHeaderMobile';
import Navigation from '../Navigation/Desktop';
import MobileNavigation from '../Navigation/Mobile';
import SocialLinks from '../SocialLinks';

const Header = ({ pathname }) => {
  const decorationDataLeft = {
    vertical: -180, // ajuste conforme necessário
    horizontal: 'left', // ajuste conforme necessário
    image: 'plant1',
  };

  const decorationDataRight = {
    vertical: -180, // ajuste conforme necessário
    horizontal: 'right', // ajuste conforme necessário
    image: 'plant1',
  };

  const decorationDataPlant4 = {
    vertical: 760, // ajuste conforme necessário
    horizontal: 'left', // ajuste conforme necessário
    image: 'plant4',
  };

  // const decorationDataParrot = {
  //   vertical: 1480, // ajuste conforme necessário
  //   horizontal: 'right', // ajuste conforme necessário
  //   image: 'parrot',
  // };

  const showDecorations = ['/pt-br', '/en', '/es'].includes(pathname);

  return (
    <header className="site-header">
      <div className="tools-wrapper">
        <SocialLinks />
        <div className="tools">
          <LanguageSelector />
          <MobileNavigation pathname={pathname} />
        </div>
      </div>

      <div className="logo">
        <LogoHeaderDesktop className="c-desktop" />
        <LogoHeaderMobile className="c-mobile" />
      </div>

      <Container>
        <div className="nav-wrapper">
          <Navigation pathname={pathname} />
          <div className="search">
            <SearchWidget />
          </div>
        </div>
      </Container>
      {showDecorations && (
        <>
          <Body data={decorationDataLeft} isEditMode={false} />
          <Body data={decorationDataRight} isEditMode={false} />
          <Body data={decorationDataPlant4} isEditMode={false} />
        </>
      )}
    </header>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};

export default Header;
